var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAction = function SvgAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 140 112"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#action_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#action_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "action_svg__c",
    width: 70,
    height: 70,
    x: 35,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.849,
    cy: 43.357,
    r: 34.623,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#action_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#274095",
    d: "M100.408 6H39.244a6.97 6.97 0 0 0-6.97 6.97v61.165a6.97 6.97 0 0 0 6.97 6.97h61.164a6.97 6.97 0 0 0 6.971-6.97V12.97A6.97 6.97 0 0 0 100.408 6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#29ABE2",
    d: "M69.821 8.57c-19.334 0-35.006 15.67-35.006 35.005s15.672 35.006 35.006 35.006c19.335 0 35.006-15.671 35.006-35.006 0-19.334-15.662-35.006-35.006-35.006m0 66.886c-17.603 0-31.88-14.268-31.88-31.88 0-17.613 14.268-31.872 31.88-31.872 17.613 0 31.881 14.268 31.881 31.88 0 17.613-14.268 31.881-31.88 31.881z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000058",
    d: "M106.639 6 82.85 10.686 53.04 50.678l-3.533-3.533-6.49 6.49 4 4L32 72.654l6.707 6.7 15.444-14.576 3.775 3.792 6.49-6.49-3.533-3.541 40.986-29.694z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000058",
    d: "m105.586 10.97-22.735 4.627-29.81 39.992-5.697-6.281-6.966 6.782 6.64 6.457L34.464 75.1l7.142 7.141L54.16 69.688l3.775 3.792 9.13-9.129-3.526-3.266L100.9 33.63z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ADAFB",
    d: "m105.586 8.514-22.735 4.628-29.81 39.992-3.534-3.534-6.49 6.49 4.001 4.001-12.554 12.554 7.142 7.142L54.16 67.233l3.775 3.792 6.49-6.49-3.533-3.542 40.008-29.81 4.686-22.66z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2765",
    d: "M57.826 55.664c1.128-1.178 2.28-2.405 3.483-3.633 1.186-1.228 2.406-2.464 3.617-3.717 1.228-1.228 2.456-2.464 3.667-3.667 1.202-1.211 2.413-2.38 3.583-3.525 2.33-2.28 4.527-4.376 6.44-6.155 3.8-3.567 6.44-5.856 6.44-5.856s-2.247 2.665-5.764 6.515a376 376 0 0 1-6.072 6.515c-1.128 1.178-2.28 2.406-3.483 3.634-1.186 1.227-2.406 2.464-3.617 3.717-1.228 1.227-2.455 2.464-3.667 3.666-1.202 1.212-2.413 2.38-3.583 3.533"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000058",
    d: "m97.033 53.635-6.49-6.49-3.533 3.533L57.2 10.686 33.353 6l4.794 22.736L79.16 58.538l1.236 3.324 1.72 6.707 3.776-3.792 12.554 12.554 7.141-7.142-12.554-12.553"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000058",
    d: "M99.405 55.99 93 49.6l-5.989 5.99L57.2 15.596 34.464 10.97l4.686 22.66 37.403 27.89-3.3 3.107 8.854 8.853 3.775-3.792 12.554 12.554 9.556-9.555-12.53-12.696"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0FFFF",
    d: "m97.033 56.09-6.49-6.49-3.533 3.534L57.2 13.142 34.464 8.514l4.686 22.66 40.009 29.811-3.542 3.541 6.498 6.49 3.776-3.792 12.554 12.554 7.141-7.141-12.554-12.554"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2765",
    d: "M82.224 55.664c-1.128-1.178-2.28-2.405-3.483-3.633-1.186-1.228-2.406-2.464-3.617-3.717-1.227-1.228-2.455-2.464-3.666-3.667-1.203-1.211-2.414-2.38-3.584-3.525a358 358 0 0 0-6.44-6.155c-3.8-3.567-6.44-5.856-6.44-5.856s2.248 2.665 5.764 6.515c1.754 1.93 3.825 4.16 6.072 6.515 1.128 1.178 2.28 2.406 3.483 3.634 1.186 1.227 2.406 2.464 3.617 3.717 1.228 1.227 2.456 2.464 3.667 3.666 1.202 1.212 2.414 2.38 3.583 3.533"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "current",
    clipPath: "url(#action_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.86 103.14c.52 0 .96.16 1.33.48s.54.7.54 1.13c0 .46-.18.85-.54 1.16s-.81.47-1.33.47h-7.99c-.48 0-.92-.16-1.3-.47s-.57-.7-.57-1.16V92.68c0-.42.18-.79.53-1.13.35-.33.8-.5 1.34-.5h7.99c.52 0 .96.16 1.33.48.36.32.54.71.54 1.15s-.18.85-.54 1.15-.81.46-1.33.46h-6.14v2.74h4.27c.5 0 .94.16 1.31.48s.56.7.56 1.15-.19.83-.56 1.14-.81.47-1.31.47h-4.27v2.88h6.15zm16.76.51c.37.32.56.7.56 1.14s-.19.83-.56 1.16c-.37.3-.82.46-1.33.46s-.96-.15-1.35-.46l-6.51-4.94v3.77q0 .675-.54 1.14c-.36.31-.81.47-1.35.47s-.97-.16-1.34-.47-.56-.69-.56-1.14v-12.1c0-.43.19-.81.56-1.13s.82-.48 1.34-.48.99.16 1.35.48.54.7.54 1.13v3.77l6.51-4.9q.585-.48 1.35-.48c.51 0 .95.16 1.33.48.37.32.56.7.56 1.14s-.19.82-.56 1.14l-6.54 4.9zm9.14 2.66c-.97 0-1.86-.15-2.68-.46-.82-.3-1.53-.72-2.14-1.25a5.7 5.7 0 0 1-1.42-1.85c-.34-.7-.53-1.46-.54-2.26v-7.95c0-.42.19-.77.56-1.06s.8-.43 1.29-.43.91.16 1.29.47c.37.31.56.68.56 1.09v8.02c0 .35.08.69.25 1.01s.39.59.67.82c.28.22.61.4.98.54s.76.2 1.17.2c.45 0 .86-.07 1.24-.22.38-.14.72-.34 1.01-.58s.51-.52.67-.85.24-.68.24-1.04v-7.97c0-.43.18-.79.54-1.07s.8-.42 1.3-.42c.5.02.93.18 1.27.48s.52.67.52 1.08v8.09c0 .8-.19 1.54-.56 2.23s-.87 1.28-1.48 1.79c-.61.5-1.33.9-2.15 1.18s-1.68.42-2.57.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.95 106.31c-.97 0-1.86-.15-2.68-.46-.82-.3-1.53-.72-2.14-1.25a5.7 5.7 0 0 1-1.42-1.85c-.34-.7-.53-1.46-.54-2.26v-7.95c0-.42.19-.77.56-1.06s.8-.43 1.29-.43.91.16 1.29.47c.37.31.56.68.56 1.09v8.02c0 .35.08.69.25 1.01s.39.59.67.82c.28.22.61.4.98.54s.76.2 1.17.2c.45 0 .86-.07 1.24-.22.38-.14.72-.34 1.01-.58s.51-.52.67-.85.24-.68.24-1.04v-7.97c0-.43.18-.79.54-1.07s.8-.42 1.3-.42c.5.02.93.18 1.27.48s.52.67.52 1.08v8.09c0 .8-.19 1.54-.56 2.23s-.87 1.28-1.48 1.79c-.61.5-1.33.9-2.15 1.18s-1.68.42-2.57.42zm23.72-3.49c-.35.71-.84 1.33-1.45 1.86s-1.34.94-2.17 1.25c-.83.3-1.71.46-2.64.46h-4.89c-.52 0-.96-.16-1.33-.47q-.54-.465-.54-1.14V92.61q0-.675.54-1.14c.36-.31.81-.47 1.33-.47s.96.16 1.33.47q.54.465.54 1.14v2.11h3.02c.93 0 1.81.15 2.64.46.83.3 1.55.72 2.17 1.25.61.53 1.1 1.15 1.45 1.86s.53 1.47.53 2.27-.18 1.56-.53 2.27zm-3.45-3.29c-.16-.31-.38-.59-.66-.83s-.61-.43-.98-.56c-.37-.14-.76-.2-1.17-.2h-3.02v5.23h3.02c.41 0 .8-.07 1.17-.2.37-.14.7-.32.98-.56q.42-.36.66-.84c.16-.32.24-.66.24-1.01s-.08-.71-.24-1.02zm17.3-8.46c.48 0 .93.15 1.33.46.4.3.6.69.6 1.15v12.1q0 .315-.15.6c-.1.19-.25.36-.43.52q-.285.225-.63.36c-.23.09-.47.13-.71.13-.45 0-.86-.16-1.23-.47s-.56-.69-.56-1.14v-3.94h-6.09v3.94q0 .675-.54 1.14c-.36.31-.81.47-1.33.47-.58 0-1.05-.15-1.41-.46s-.55-.69-.57-1.15v-12.1c0-.5.2-.89.6-1.18s.86-.43 1.38-.43.96.16 1.33.48.54.7.54 1.13v4.9h6.09v-4.9c0-.43.19-.81.56-1.13q.555-.48 1.23-.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1 94.63h2.37L85.52 91h-3.35c-.42 0-.78.17-1.08.52s-.46.77-.48 1.27c0 .5.14.94.42 1.3s.64.54 1.07.54"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "action_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h140v112H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "action_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 91h85.45v15.41H27z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "action_svg__b",
    width: 95.992,
    height: 96.242,
    x: 22,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2438_6330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2438_6330",
    result: "shape"
  })))));
};
export default SvgAction;